import { useState } from 'react';
import {
  Page,
  Header,
  Content,
} from '@backstage/core-components';
import { Tabs, Tab } from '@material-ui/core';
import { useLocation } from 'react-router-dom';
import { EnvironmentsPage } from '../environments/EnvironmentsPage';
import { ReleaseHistoryPage } from './ReleaseHistoryPage';
import { GrafanaPage } from './GrafanaPage';

export const AwsPage = () => {
  const location = useLocation();
  const tabParam = new URLSearchParams(location.search).get('tab');
  const initialTab = tabParam === 'release-history' ? 1 : tabParam === 'monitoring' ? 2 : 0;
  const [tab, setTab] = useState(initialTab);

  return (
    <Page themeId="tool">
      <Header title="Environments" subtitle="Infrastructure across all environments" />
      <Content>
        <Tabs
          value={tab}
          onChange={(_, v) => setTab(v)}
          indicatorColor="primary"
          textColor="primary"
          style={{ marginBottom: 24, borderBottom: '1px solid rgba(255,255,255,0.12)' }}
        >
          <Tab label="Environments" />
          <Tab label="Release History" />
          <Tab label="Monitoring" />
        </Tabs>
        {tab === 0 && <EnvironmentsPage />}
        {tab === 1 && <ReleaseHistoryPage />}
        {tab === 2 && <GrafanaPage />}
      </Content>
    </Page>
  );
};
